import React from 'react'

import IconButton from 'components/forms/IconButton'
import TrashIcon from 'components/icons/TrashIcon'
import EditIcon from 'components/icons/EditIcon'

/**
 * Actions cell for table
 * @param {object} props
 * @param {*} props.item
 * @param {function} [props.onRemove]
 * @param {function} [props.onEdit]
 *
 * @returns {React.Component}
 */
export default function ActionsCell(props) {
  const { item, onRemove, onEdit } = props

  return (
    <div
      className='nx-basic-table__body-cell nx-basic-table__actions'
    >
      {
        onEdit
          ? (
            <IconButton
              onClick={() => onEdit(item)}
              className='nx-basic-table__icon-actions'
            >
              <EditIcon size='inherit' />
            </IconButton>
          )
          : null
      }
      {
        onRemove
          ? (
            <IconButton
              onClick={() => onRemove(item)}
              className='nx-basic-table__icon-actions'
            >
              <TrashIcon size='inherit' />
            </IconButton>
          )
          : null
      }
    </div>
  )
}
